module.exports = __webpack_public_path__ + "static/img/demo.6c20488.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/demo.png
// module id = 0BXt
// module chunks = 1